export const RedirectRoutes = {
    AsimsAdmin: "https://" + process.env.REACT_APP_ASIMS_URL + "/admin",
    AsimsCustomer: "https://" + process.env.REACT_APP_ASIMS_URL + "/customer",
    InspectionSurveyorPortal: "https://" + process.env.REACT_APP_PORTAL_URL,
    IdPlatform: "https://" + process.env.REACT_APP_ID_PLATFORM_URL
};
